<template>
    <div class="screen" style="padding:0 30px;">
        <div @click="btnHome()" class="hand" style="color: white;position: fixed;left: -2px;top: 5%;transform: translateY(-50%);height: 50px;width: 300px;">
            <!-- <img style="height: 40px;" src="../../src/assets/main/home.png" alt=""> -->
        </div>
       
        <div @click="btnArrow('L')" class="hand" style="color: white;position: fixed;left: -15px;top: 50%;transform: translateY(-50%);"><img style="height: 50px;" src="../../src/assets/main/arrowL.png" alt=""></div>
           <div  @click="btnArrow('R')" class="hand"     style="color: white;position: fixed;right: -15px;top: 50%;transform: translateY(-50%);"><img style="height: 50px;" src="../../src/assets/main/arrowR.png" alt=""></div>

                <van-col class="h100" span="24"><iframe ref="iframe" :src="urlList[index]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>

<!--   
    <van-row v-if="index===3"  class="h33" >
    <van-col class="h100" span="24"><iframe ref="iframe" :src="urlList[0+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="24"><iframe ref="iframe" :src="urlList[1+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="24"><iframe ref="iframe" :src="urlList[2+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    </van-row>


   <van-row v-if="index===4"  class="h50" >
    <van-col class="h100" span="12"><iframe ref="iframe" :src="urlList[0+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="12"><iframe ref="iframe" :src="urlList[1+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    </van-row>
      <van-row v-if="index===4"  class="h50" >
    <van-col class="h100" span="12"><iframe ref="iframe" :src="urlList[2+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="12"><iframe ref="iframe" :src="urlList[3+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    </van-row>


        <van-row v-if="index===6" class="h50" >
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[0+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[1+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[2+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    </van-row>
      <van-row v-if="index===6" class="h50"  >
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[3+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
       <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[4+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[5+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    </van-row>



        <van-row v-if="index===9" class="h33" >
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[0+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[1+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[2+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    </van-row>
       <van-row v-if="index===9" class="h33" >
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[3+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[4+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[5+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    </van-row>
       <van-row v-if="index===9" class="h33" >
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[6+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[7+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    <van-col class="h100" span="8"><iframe ref="iframe" :src="urlList[8+indexAdd]"  width="100%" height="100%" frameborder="0" ></iframe></van-col>
    </van-row> -->

    </div>
</template>

<script>
const nameList=[ 
        'bottom','bigop/2689E844B02048C28DEE33577FFCECCE','supply',
         'design', 'vip11', 'digitalproduction_1' ,'capacity',
         'digitalproduction_2', 'online', 'production_schedule',
          'marketing',  'operate11', 'quality_testing',
           'warehouse'
        ]
export default {
    name: 'WorkspaceJsonTest',

    data() {
        return {
            urlList:[],
            index:3,
            result:[],
            indexList:[],
            indexAdd:0
        };
    },

    created() {
       this.index=Number(this.$route.query.index)-1//4,6,9
        let preUrl=window.location.host
        nameList.forEach(item=>{
            // if(item==='vip2'||item==='operate'){
            //     this.urlList.push('http://'+preUrl+'/#/'+item) 
            // }else{
                this.urlList.push('http://'+preUrl+'/#/platm/'+item) 
            // }
        })
    //    let  arr=JSON.parse(this.$route.query.result)//[]
    //     arr.forEach(item=>{
    //             this.result.push(this.urlList[item]) 
    //     })
    },
    mounted(){
       console.log( this.$refs.iframe)
    },
    methods: {
        btnHome(){
            this.$router.push('./main')
        },
        btnArrow(e){
            if(e==='L'){
                 if(this.index>0) this.index-=1
            }


            if(e==='R'){ 
                 if(this.index<12) this.index+=1
            }

        }
    },
};
</script>

<style lang="scss" scoped>
.screen{
     background-size: 100% 100%;
       background-image: url(../assets/bg.png);
       display: flex;
       flex-direction: column;
       height: 100%;
       min-width: 1280px;
       min-height: 720px;
}
.h100{
    height: 100%;
}
.h50{
    height: 50%;
}
.h33{
    height: 33.3%;
}
.hand:hover{
    cursor: pointer;
}
</style>